export const DEFAULT_ZOOM = 7;
export const DEFAULT_CENTER = [27.561824, 53.90574];
export const MAX_ZOOM = 17;
